import { createSelector } from 'reselect';

import * as Constants from '../constants';

function getMessages(state: $TSFixMe): $TSFixMe {
  return state.i18n.get(Constants.i18n.stateKeys.MESSAGES);
}

export function getLocale(state: $TSFixMe): $TSFixMe {
  return state.i18n.get(Constants.i18n.stateKeys.LOCALE);
}

export function getDefaultLocale(): string {
  // when we're on this locale we won't show errors when
  // messages aren't provided and we fall back to default messages.
  // This is set to en-US while we don't need translations, but it
  // should not be so when we do since it provides valuable errors
  // to indicate strings that don't have translations.
  return 'en-US';
}

export const getMessagesSelector = createSelector(getMessages, messages => {
  return messages.toJS();
});
